var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPolicies(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8333 5.00049C13.9006 5.00049 11.6423 3.88636 10.0921 2.53369L10.0492 2.5083C10.0337 2.50259 10.0171 2.49955 10.0003 2.49951C9.96743 2.49951 9.93487 2.51084 9.90952 2.53174C8.36835 3.87618 6.1006 5.00049 4.16635 5.00049V10.8335C4.16635 12.6968 4.8093 14.0516 5.8226 15.0894C6.72902 16.0175 7.96102 16.7208 9.37827 17.27L9.99741 17.4956L10.016 17.5024C11.6868 16.9193 13.1441 16.1512 14.1781 15.0903C15.1908 14.0512 15.8333 12.6967 15.8333 10.8335V5.00049ZM17.5003 10.8335C17.5003 13.1369 16.6837 14.9071 15.3714 16.2534C14.082 17.5764 12.3507 18.4537 10.558 19.0786L10.5511 19.0815C10.1881 19.2046 9.79316 19.1988 9.43393 19.0649V19.063C7.64329 18.4426 5.91659 17.5707 4.63022 16.2534C3.31643 14.9079 2.50034 13.1369 2.50034 10.8335V5.00049C2.50034 4.55846 2.67606 4.13434 2.98862 3.82178C3.30108 3.50941 3.72453 3.33358 4.16635 3.3335C5.56334 3.3335 7.45995 2.45989 8.8187 1.27295L8.82553 1.26611V1.26709C9.15297 0.987337 9.56966 0.833496 10.0003 0.833496C10.3771 0.833564 10.7433 0.950647 11.0482 1.16748L11.1751 1.26709L11.182 1.27295C12.5482 2.4674 14.4358 3.3335 15.8333 3.3335C16.2754 3.3335 16.6995 3.50922 17.0121 3.82178C17.3245 4.13433 17.5003 4.55853 17.5003 5.00049V10.8335Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolicies);
export default __webpack_public_path__ + "static/media/policies.d92640138418dfb9bb91cde2bd83fb10.svg";
export { ForwardRef as ReactComponent };